<template>
  <form @submit.prevent="submit" class="embed-contact">
    <InputComponent
      v-model="data.contact.name"
      :label="labels['contact.name']"
      required
      :is-valid="validator.fields['contact.name'].valid"
      :validation-message="validator.fields['contact.name'].error"
    />
    <InputComponent
      v-model="data.contact.email"
      :label="labels['contact.email']"
      required
      :is-valid="validator.fields['contact.email'].valid"
      :validation-message="validator.fields['contact.email'].error"
    />
    <InputComponent
      v-model="data.contact.phone"
      :label="labels['contact.phone']"
      required
      :is-valid="validator.fields['contact.phone'].valid"
      :validation-message="validator.fields['contact.phone'].error"
    />

    <Tags
      label="Hvilke boligtyper er du interessert i?"
      v-model="data.contact.tags"
      :placeholder="$t('select') + '...'"
      :autocomplete="
        ['Hitra', 'Hovden', 'Jakob', 'Fedje', 'Askøy', 'Aurora', 'Frøvik', 'Bergsmo', 'Høvik 2'].map(v => ({
          text: v,
        }))
      "
      add-only-from-autocomplete
      :autocomplete-min-length="0"
    />

    <InputComponent
      :label="labels.comment"
      :is-valid="validator.fields.comment.valid"
      :validation-message="validator.fields.comment.error"
    >
      <textarea v-model="data.comment" class="elder-input__element"></textarea>
    </InputComponent>

    <CheckboxComponent v-model="privacyAccepted" required>
      <i18n path="leadPrivacy" tag="span">
        <a href="/api/legal/privacy/tenant">{{ $t('privacy').toLowerCase() }}</a>
      </i18n>
    </CheckboxComponent>

    <div class="row center mt-2">
      <ButtonComponent
        :label="$t('send')"
        theme="primary"
        type="submit"
        :icon="['fal', 'arrow-to-right']"
        :promise="promise"
      />
    </div>
  </form>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import Tags from '@/components/Tags'

import { mapi18n } from '@/i18n'
import Validator from '@/mixins/validator-v2'
import Model from '@/mixins/Model'

export default {
  props: {},
  mixins: [
    Validator({
      rules: {
        'contact.name': 'required',
        'contact.email': 'required|email',
        'contact.phone': 'required|phone',
        comment: 'string',
      },
      labels: 'labels',
      data: 'data',
    }),
    Model({
      model: {
        contact: {
          name: null,
          email: null,
          phone: null,
          upsell: false,
          tags: [],
        },
        comment: null,
      },
    }),
  ],
  data() {
    return {
      privacyAccepted: false,
      promise: null,
    }
  },
  computed: {
    ...mapi18n('labels', {
      'contact.name': 'name',
      'contact.email': 'email',
      'contact.phone': 'phone',
      'contact.upsell': 'contactUpsell',
      comment: 'leadMessage',
      residentialTemplates: ['residentialTemplate', 2],
    }),
  },
  methods: {
    submit() {
      if (!this.validator.passes || !this.privacyAccepted) return
      // this.promise = API.createLead({
      //   ...Clone(this.data),
      //   project: this.project,
      //   references: this.reference ? [this.reference] : [],
      // }).then(() => {
      //   this.$tracker.lead()
      //   let { comment, ...rest } = this.data
      //   sessionStorage.setItem('lead', JSON.stringify(rest))
      //   this.$emit('onSubmit')
      //   this.reset()
      // })
    },
  },
  created() {
    this.resetData()
  },
  components: {
    InputComponent,
    CheckboxComponent,
    Tags,
  },
}
</script>

<style lang="scss">
.embed-contact {
  background-color: white;
  border-radius: $border-radius;

  display: grid;
  grid-gap: 1rem;

  margin: auto;
  border: 1px solid var(--border-color);
  padding: 2rem;
  width: 100%;
  max-width: 600px;
}
</style>
